/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DiscordRelayMessageHistoryMessages
 */
export interface DiscordRelayMessageHistoryMessages {
    /**
     * 
     * @type {string}
     * @memberof DiscordRelayMessageHistoryMessages
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscordRelayMessageHistoryMessages
     */
    channelId?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscordRelayMessageHistoryMessages
     */
    guildId?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscordRelayMessageHistoryMessages
     */
    content?: string;
    /**
     * 
     * @type {Date}
     * @memberof DiscordRelayMessageHistoryMessages
     */
    timestamp?: Date;
    /**
     * 
     * @type {object}
     * @memberof DiscordRelayMessageHistoryMessages
     */
    author?: object;
}

export function DiscordRelayMessageHistoryMessagesFromJSON(json: any): DiscordRelayMessageHistoryMessages {
    return DiscordRelayMessageHistoryMessagesFromJSONTyped(json, false);
}

export function DiscordRelayMessageHistoryMessagesFromJSONTyped(json: any, ignoreDiscriminator: boolean): DiscordRelayMessageHistoryMessages {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'channelId': !exists(json, 'channelId') ? undefined : json['channelId'],
        'guildId': !exists(json, 'guildId') ? undefined : json['guildId'],
        'content': !exists(json, 'content') ? undefined : json['content'],
        'timestamp': !exists(json, 'timestamp') ? undefined : (new Date(json['timestamp'])),
        'author': !exists(json, 'author') ? undefined : json['author'],
    };
}

export function DiscordRelayMessageHistoryMessagesToJSON(value?: DiscordRelayMessageHistoryMessages | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'channelId': value.channelId,
        'guildId': value.guildId,
        'content': value.content,
        'timestamp': value.timestamp === undefined ? undefined : (value.timestamp.toISOString()),
        'author': value.author,
    };
}


